<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    v-model="selected"
    :menu-props="{ offsetY: true, overflowY: true, closeOnContentClick: true }"
    :items="items"
    item-text="text"
    item-value="value"
  >
  </v-select>
</template>

<script>
  import bloodTypes from "./bloodTypes";

  export default {
    inheritAttrs: false,
    name: "BloodTypesPicker",
    props: {
      value: [String, Array]
    },
    data: () => ({
      items: bloodTypes,
      selected: null
    }),
    watch: {
      value: {
        handler(v) {
          this.selected = v;
        },
        immediate: true
      }
    }
  };
</script>

<style scoped></style>
